// extracted by mini-css-extract-plugin
export default {"-large":"uOhzFNB6E3qoYxxe6_ed","button":"VNbf0zIRTJruPMFJLNo3","shineAnimation":"mtIKgU44so1FwM7r3FL_","ShineAnimation":"Z_oDJ2E1p5X48eKXZftA"};